import { ReactComponent as ReportIcon } from '@Icons/menu/reports.svg';

import { BaseNameSideItem } from '../../../../../enum';
import { MenuItem } from '../../../types';
import { createItem } from '../../../utils/createItem';

const ReportsMenuItem: MenuItem = createItem(
  BaseNameSideItem.REPORTS,
  BaseNameSideItem.REPORTS,
  <ReportIcon />
);

export default ReportsMenuItem;
